"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorState = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../shared/core");
var copy_1 = require("../copy");
var ErrorState = function (_a) {
    var error = _a.error, type = _a.type;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var Callout = (0, core_1.useComponents)().Callout;
    switch (error) {
        case 'SCHEDULE_DAY_TODAY':
            return (react_1.default.createElement(Callout, { variant: "warning", "data-testid": "error-schedule-day-today" },
                react_1.default.createElement(Copy, { copyKey: "updateDirectDebit".concat(type, "ErrorScheduleDayToday") })));
        case 'NO_BOOKED_PAYMENT':
            return (react_1.default.createElement(Callout, { variant: "warning", "data-testid": "error-no-booked-payment" },
                react_1.default.createElement(Copy, { copyKey: "updateDirectDebit".concat(type, "ErrorNoBookedPayment") })));
        case 'FREQUENCY_UNSUPPORTED':
            return (react_1.default.createElement(Callout, { variant: "warning", "data-testid": "error-frequency-unsupported" },
                react_1.default.createElement(Copy, { copyKey: "updateDirectDebit".concat(type, "ErrorFrequencyUnsupported") })));
        case 'DOES_NOT_OWN_MANDATE':
            return (react_1.default.createElement(Callout, { variant: "warning", "data-testid": "error-does-not-own-mandate" },
                react_1.default.createElement(Copy, { copyKey: "updateDirectDebit".concat(type, "ErrorDoesNotOwnMandate") })));
        case 'NO_SCHEDULE':
            return (react_1.default.createElement(Callout, { variant: "warning", "data-testid": "error-does-not-own-mandate" },
                react_1.default.createElement(Copy, { copyKey: "updateDirectDebitErrorNoSchedule" })));
        default:
            return (react_1.default.createElement(Callout, { variant: "warning", "data-testid": "error-generic" },
                react_1.default.createElement(Copy, { copyKey: "updateDirectDebit".concat(type, "ErrorGeneric") })));
    }
};
exports.ErrorState = ErrorState;
